module.exports = __webpack_public_path__ + "img/gb9123_19_b.prt.47969cf3.jpg";